import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  getFolderList,
  getMindfileItem,
  getMindfileItemLocations,
  getMindfileItems,
  getMindfileItemsDetails,
  getFolderDetails,
  setSelectedItems
} from '../../../../state/actions/getDataActions';
import {getFilterValues} from '../../../../state/actions/getFilterDataActions';
import {
  addFolder,
  moveFolderItems,
  moveItems,
  updateItemViewCount,
  removeFoldersAndDeleteItems,
  removeFoldersAndMoveItems,
  removeItems,
  updateFolders
} from '../../../../state/actions/updateDataActions';
import {
  bemeCell,
  createdCell,
  dateCell,
  descriptionCell,
  emotionCell,
  extensionCell, fieldCell, fieldCellSm,
  folderNameCell,
  formatItemDataType,
  iconCell,
  keywordsCell,
  locationCell,
  nameCell,
  peopleCell,
  selectCell,
  sizeCell,
  sourceCell,
  statusCell,
  updatedCell
} from '../items/list-view/ItemCells';
import ItemsPage from '../items/table/ItemsPage';
import FolderDetails from "./FolderDetails";
import {withStyles} from "@material-ui/core/styles";
import BindViewOptions from "../../../util/data-table/BindViewOptions";
import {Link} from 'react-router-dom';
import {Button} from "@material-ui/core";
import {surveyCompletion} from "../items/ProfileExplorer";

const styles = {
  titleLabel:{
    fontSize:'0.65em',
    // fontWeight:400,
    marginRight:'0.25rem',
    // textTransform:'uppercase',
    wordBreak:'keep-all',
    display:'inline-block',
  },
  titleLink:{
    padding: 0,
    fontWeight:400,
    // textDecoration: 'underline',
    textTransform:'none',
    fontSize: '1rem',
    '&:hover':{
      opacity: 0.85,
      textDecoration: 'underline',
      backgroundColor: 'inherit'
    }
  }
};

class FolderView extends Component {
  folderId = this.props.match.params.folderId;

  filterDefinitions = [
    { label: "Status", key: "status", enabled: true, visible: true, options: (opts) => [{name:'Active', value: 1}, {name: 'Pending', value: 0}] },
    { label: "Keywords", key: "keywords", enabled: true, visible: true, options: (opts) => opts ? (opts.keywords || []).map((k) => ({value: k.id, name: k.text})) : [] },
    { label: "People", key: "people", enabled: true, visible: true, options: (opts) => opts ? (opts.people || []).map((p) => ({value: p.id, name: p.name})) : [] },
    { label: "Folders", key: "folders", enabled: true, visible: false, options: (opts) => opts ? (opts.folders || []).map((f) => ({value: f.id, name: f.name})) : [] },
    { label: "Emotions", key: "emotions", enabled: true, visible: true, options: (opts) => opts ? (opts.emotions || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Bemes", key: "bemes", enabled: true, visible: true, options: (opts) => opts ? (opts.bemes || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Item Types", key: "item_data_types", enabled: true, visible: false, options: (opts) => opts ? (opts.item_data_types || []).map((e) => ({value: e, name: formatItemDataType(e)})) : [] },
    { label: "File Type", key: "upload_types", enabled: true, visible: true, options: (opts) => opts ? (opts.upload_types || []).map((e) => ({value: e, name: e.charAt(0).toUpperCase() + e.slice(1)})) : [] },
    { label: "Sources", key: "sources", enabled: true, visible: true, options: (opts) => opts ? (opts.sources || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Assessment", key: "survey_names", enabled: true, visible: true, options: (opts) => opts ? (opts.survey_names || []).map((e) => ({value: e, name: e})) : [] },
    { label: "Assessment Status", key: "survey_complete", enabled: true, visible: true, options: (opts) => [{name:'Complete', value: 1}, {name: 'In Progress', value: 0}] },
  ];

  columns = [
    {key: 'selected', header: {label: '', sort: null }, cell: selectCell, enabled: true},
    {key: 'type', header: [
        { label: 'Type', sort: 'mindfile_items.item_data_type' },
        { label: 'Status', sort: 'mindfile_items.status', asc: false },
      ], cell: statusCell, enabled: true },
    {key: 'icon', header: {label: '', sort: null }, cell: iconCell, enabled: true },
    {key: 'name', header: { label: 'Name', sort: 'mindfile_items.name' }, cell: nameCell, enabled: true },

    {key: 'survey_name', header: { label: 'Assessment', sort: 'surveys.name', asc: true, size:"normal" },
      cell: fieldCell(item => item.item_data?.survey?.name || null), enabled: true, hidden: true,
      viewText: item => item.item_data?.survey?.name || "", viewPlacement: "tags", viewEnabled: item => item?.item_data_type === "SurveyAttempt",
      action: (i) => this.addFilterSelectByName('Assessment', i?.item_data?.survey?.name),
    },
    {key: 'survey_completion', header: [
        { label: 'Completion', sort: 'survey_completion', asc: false, size:"normal" },
        { label: 'Answers', shortLabel: 'Ans.', sort: 'survey_attempts.answer_count', asc: false, size:"normal" },
        { label: 'Questions', shortLabel: 'Ques.', sort: 'surveys.question_count', asc: false, size:"normal" },
      ],
      cell: fieldCellSm(surveyCompletion), enabled: true, hidden: true, viewText: surveyCompletion, viewPlacement: "tags",
      viewEnabled: item => item?.item_data_type === "SurveyAttempt",
      action: (i) => {
        const complete = i?.item_data?.answer_count >= i.item_data?.survey?.question_count ? 1 : 0
        this.addFilterSelectByName('Assessment Status', complete)
      },
    },
    {key: 'description', header: { label: 'Description', sort: 'mindfile_items.description', nulls: true }, cell: descriptionCell, enabled: true },
    {key: 'date', header: { label: 'Date', sort: 'mindfile_items.date', asc: false, nulls: true }, cell: dateCell, enabled: true },
    {key: 'location', header: [
        { label: 'Location', sort: 'locations.country', nulls: true },
        {label:'Latitude', shortLabel: 'Lat', sort: 'locations.latitude', nulls: true },
        {label:'Longitude', shortLabel: 'Lng', sort: 'locations.longitude', nulls: true },
      ], cell: locationCell, enabled: true },
    {key: 'keywords', header: { label: 'Keywords', sort: 'keywords.text', asc: false, nulls: true }, cell: keywordsCell, enabled: true, action: (id) => this.addFilterSelectByName('Keywords', id)},
    {key: 'people', header: { label: 'People', sort: 'people.name', asc: false, nulls: true }, cell: peopleCell, enabled: true, action: (id) => this.addFilterSelectByName('People', id) },
    {key: 'emotion', header: { label: 'Emotion', sort: 'mindfile_items.emotion', nulls: true }, cell: emotionCell, enabled: true, action: (emotion) => this.addFilterSelectByName('Emotions', emotion) },
    {key: 'beme', header: { label: 'Beme', sort: 'mindfile_items.beme', nulls: true }, cell: bemeCell, enabled: true, action: (beme) => this.addFilterSelectByName('Bemes', beme) },
    {key: 'created', header: { label: 'Added', sort: 'mindfile_items.created_at', asc: false }, cell: createdCell, enabled: true },
    {key: 'updated', header: { label: 'Modified', sort: 'mindfile_items.updated_at', asc: false }, cell: updatedCell, enabled: true },
    {key: 'extension', header:  {label:'Extension', shortLabel: 'Ext', sort: 'uploads.extension', nulls: true }, cell: extensionCell, enabled: true, hidden: false },
    {key: 'size', header: { label: 'Size', sort: 'uploads.size', asc: false, nulls: true }, cell: sizeCell, enabled: true, hidden: false },
    {key: 'source', header: { label: 'Source', sort: 'uploads.source', nulls: true }, cell: sourceCell, enabled: true, hidden: false },
    {key: 'folderName', header: { label: 'Folder', sort: 'folders.name' }, cell: folderNameCell, enabled: true, action: true },
  ];

  filters = this.filterDefinitions.map((filter, index) => ({
    ...filter, index: index, handleSelect: this.handleFilterSelect.bind(this, index), addFilterSelect: this.addFilterSelect.bind(this, index)
  }))

  defaultViewOpts = {
    rowsPerPage: 12,
    orders: [{f: 'mindfile_items.updated_at', d: false, n: true}],
    viewMode: 'List',
    iconSize: 'Medium',
    visibleColumns: Object.assign({}, ...this.columns.filter(col => col.enabled).map(c => ({[c.key]: !c.hidden})))
  };

  defaultFilters = (filters) => [
    { key: "status", selectedItems: [], },
    { key: "keywords", selectedItems: [], },
    { key: "people", selectedItems: [], },
    { key: "folders", selectedItems: [this.props.match.params.folderId], },
    { key: "emotions", selectedItems: [], },
    { key: "bemes", selectedItems: [], },
    { key: "item_data_types", selectedItems: [], },
    { key: "upload_types", selectedItems: [], },
    { key: "sources", selectedItems: [], },
    { key: "survey_names", selectedItems: [], },
    { key: "survey_complete", selectedItems: [], },
  ];

  state = {
    pageKey:`/explore/folder/${this.folderId}`,
    title: this.getTitleDisplay(),
    loading: true,
    loadingDetails: true,
    viewOptsLoaded: false,
    controller: {
      page: 1,
      rowsPerPage: this.defaultViewOpts.rowsPerPage,
      orders: this.defaultViewOpts.orders,
      search: null,
    },
    mapBounds: null,
    items: [],
    filter_count: 0,
    folderList: [],
    filterSelections: this.defaultFilters(),
    selectedIds: [],
    tableView: {
      addButtons: ['Upload', 'Link', 'Favorite', 'JournalPost', 'SurveyAttempt'],
      viewMode: this.defaultViewOpts.viewMode,
      viewModeOptions: ['List', 'Icon', 'Stream'],
      iconSize: this.defaultViewOpts.iconSize,
      iconSizeOptions: ['Small', 'Medium', 'Large'],
      filtersOpen: false,
      columnsOpen: false,
      visibleColumns: this.defaultViewOpts.visibleColumns
    },
    addItemProps:null
  };

  handleFilterSelect(index, selections){
    let newFilters = [...this.state.filterSelections];
    newFilters[index] = {...(newFilters[index]), selectedItems: selections};
    this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelect(index, optionId){
    let newFilters = [...this.state.filterSelections];
    let newSelection = [...newFilters[index].selectedItems];
    if(newSelection.indexOf(optionId) === -1){
      newSelection.push(optionId);
      newFilters[index] = {...(newFilters[index]), selectedItems: newSelection};
    }
    this.setState({tableView: {...this.state.tableView, filtersOpen: true}, filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelectByName(filterName, optionId){
    let filter = this.filters.find(x => x.label === filterName);
    if(filter){
      filter.addFilterSelect(optionId);
    }
  }

  setFilterSelectByName(filterName, optionIds){
    let index = this.filters.findIndex(x => x.label === filterName);
    if(index < 0){
      return
    }
    let newFilters = [...this.state.filterSelections];
    newFilters[index] = {...(newFilters[index]), selectedItems: optionIds};
    this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  componentDidMount() {
    this.props.getFolderList(this.props.mindfile.id);
    this.props.getFilterValues(this.props.mindfile.id);
    this.props.setSelectedItems({});
    this.setState({loadingDetails: true});
    this.props.getFolderDetails(this.props.mindfile.id, this.folderId, (details) => {
      if(details === null){
        this.props.history.push("/explore/folders");
      }else {
        this.setState({loadingDetails: false, title: this.getTitleDisplay()})
      }
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.params.folderId !== prevProps.match.params.folderId) {
      this.folderId = this.props.match.params.folderId;
      this.setFilterSelectByName("Folders", [this.folderId])
    }
  }

  getFolderName(){
    if(this.props.folderDetails && this.props.folderDetails.name
      && this.folderId === this.props.folderDetails.id.toString()){
      return this.props.folderDetails.name;
    }
    let folderMatch = this.props.folderList.filter(f => f.id.toString() === this.folderId)
    return folderMatch.length > 0 ? folderMatch[0].name : '';
  }
  getTitleDisplay(){
    return <>
      <span className={this.props.classes.titleLabel}>
        <Button id="foldersPageLink" className={this.props.classes.titleLink} component={Link} to="/explore/folders">
          Folders
        </Button>/
      </span>
      <span>{this.getFolderName()}</span>
    </>;
  }

  handleDeleteSelectedAndDeleteItems(ids){
    // const ids = this.state.selectedIds;
    this.props.removeFoldersAndDeleteItems(ids, this.afterItemsChange.bind(this));
  }

  handleDeleteSelectedAndMoveItems(ids, destId){
    this.props.removeFoldersAndMoveItems(ids, destId, this.afterItemsChange.bind(this));
  }

  handleMoveSelected(ids, destId){
    this.props.moveFolderItems(ids, destId, () => {
      this.afterItemsChange()
    });
  }

  handleSaveFolders(folders){
    this.props.updateFolders(folders, () => this.afterItemsChange());
  }

  afterItemsChange(){
    this.fetchItems();
  }

  fetchItems(fetchLocations=false) {
    if(!this.props.mindfile.id) return;
    this.setState({loading: true});
    let fetchFilters =  Object.fromEntries(this.filters.map((f,index) => f.enabled ? [f.key, this.state.filterSelections[index].selectedItems] : null).filter(item => !!item));
    this.props.getMindfileItems(this.state.pageKey, this.props.mindfile.id, this.state.controller, fetchFilters, this.state.mapBounds, () => {
      if(this.props.mindfileFilterValues.updated) {
        this.props.getFilterValues(this.props.mindfile.id, this.props.mindfileFilterValues.updated);
      }
      this.setState({loading: false});
    });
    if(fetchLocations){
      this.props.getMindfileItemLocations(this.props.mindfile.id, this.state.controller, fetchFilters);
    }
    this.props.getFolderDetails(this.props.mindfile.id, this.folderId, () => {
      this.setState({loadingDetails: false, title: this.getTitleDisplay()})
    });
  }

  render() {
    return this.props.mindfile && this.props.addItemProps.folder ? (
      <>
        <ItemsPage
          title={this.state.title}
          displayCurrentMindfile={true}
          topPanel={this.folderId !== this.props.folderDetails.id.toString() || this.state.loadingDetails ? null : FolderDetails}
          topPanelProps={
            this.folderId !== this.props.folderDetails.id.toString() || this.state.loadingDetails ? null :
            {
              id: "folderDetails",
              folder: this.props.folderDetails,
              folderList: this.props.folderList,
              addFolder: this.props.addFolder,
              handleMoveSelected: this.handleMoveSelected.bind(this),
              handleDeleteSelectedAndDeleteItems: this.handleDeleteSelectedAndDeleteItems.bind(this),
              handleDeleteSelectedAndMoveItems: this.handleDeleteSelectedAndMoveItems.bind(this),
              handleSaveFolders: this.handleSaveFolders.bind(this),
              mindfileUserLevel: this.props.mindfileUserLevel,
            }}
          mindfileId={this.props.mindfile.id}
          itemList={this.props.itemsKey !== this.state.pageKey ? [] : this.props.items || []}
          itemCount={this.props.itemsKey !== this.state.pageKey ? 0 : this.props.filter_count}
          fetchItems={this.fetchItems.bind(this)}
          folderList={this.props.folderList}
          addFolder={this.props.addFolder}
          addItemProps={this.props.addItemProps}
          removeItems={this.props.removeItems.bind(this)}
          moveItems={this.props.moveItems.bind(this)}
          getMindfileItem={this.props.getMindfileItem.bind(this)}
          getMindfileItemsDetails={this.props.getMindfileItemsDetails.bind(this)}
          updateItemViewCount={this.props.updateItemViewCount.bind(this)}
          columns={this.columns}
          filters={this.filters}
          filterSelections={this.state.filterSelections}
          clearFilterSelections={() => this.setState({filterSelections: this.defaultFilters()})}
          addFilterSelectByName={this.addFilterSelectByName.bind(this)}
          mindfileFilterValues={this.props.mindfileFilterValues}
          selectedIds={this.state.selectedIds}
          setSelectedIds={(ids) => this.setState({selectedIds: ids})}
          selectedItems={this.props.selectedItems}
          setSelectedItems={this.props.setSelectedItems.bind(this)}
          controller={this.state.controller}
          setController={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevStateFunc(prevState, props)}})
            })
          }}
          getMindfileItemLocations={this.props.getMindfileItemLocations.bind(this)}
          mapBounds={this.state.mapBounds}
          setMapBounds={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevState.controller, page: 1}, mapBounds: prevStateFunc(prevState, props)})
            })
          }}
          loading={this.state.loading && this.state.loadingDetails}
          setLoading={(isLoading) => this.setState({loading: isLoading})}
          viewOptsLoaded={this.state.viewOptsLoaded}
          bindViewOptions={
            <BindViewOptions
              pageKey={this.state.pageKey}
              parentState={this.state}
              parentProps={this.props}
              setParentState={this.setState.bind(this)}
              defaultViewOpts={this.defaultViewOpts}
              loaded={this.state.viewOptsLoaded}
              setLoaded={loaded => this.setState({viewOptsLoaded: loaded})}
            />
          }
          addButtons={this.state.tableView.addButtons}
          viewMode={this.state.tableView.viewMode}
          setViewMode={(e) => this.setState({tableView: {...this.state.tableView, viewMode: e.target.value}})}
          viewModeOptions={this.state.tableView.viewModeOptions}
          iconSize={this.state.tableView.iconSize}
          setIconSize={(e) => this.setState({tableView: {...this.state.tableView, iconSize: e.target.value}})}
          iconSizeOptions={this.state.tableView.iconSizeOptions}
          filtersOpen={this.state.tableView.filtersOpen}
          setFiltersOpen={(open) => this.setState({tableView: {...this.state.tableView, filtersOpen: open}})}
          columnsOpen={this.state.tableView.columnsOpen}
          setColumnsOpen={(open) => this.setState({tableView: {...this.state.tableView, columnsOpen: open}})}
          visibleColumns={this.state.tableView.visibleColumns}
          setVisibleColumns={(columns) => this.setState({tableView: {...this.state.tableView, visibleColumns: columns}})}
        />
      </>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    itemsKey: state.mindfile_items?.pageKey,
    items: state.mindfile_items?.items || [],
    filter_count: state.mindfile_items?.filter_count || 0,
    canEdit: state.isCurrentMindfileContributor,
    mindfile: state.mindfile,
    folderList: state.folderList,
    mindfileFilterValues: state.mindfileFilterValues,
    folderDetails: state.folderDetails,
    addItemProps: {folder: (state.folderList || []).find(f => f.id === state.folderDetails.id)},
    selectedItems: state.selectedItems,
    mindfileUserLevel: state.mindfileUserLevel.level,
  };
}

const mapDispatchToProps = {
  getFolderList,
  getMindfileItems,
  getMindfileItemsDetails,
  getMindfileItemLocations,
  addFolder,
  removeItems,
  moveItems,
  getMindfileItem,
  getFilterValues,
  setSelectedItems,
  updateItemViewCount,
  getFolderDetails,
  removeFoldersAndDeleteItems,
  removeFoldersAndMoveItems,
  moveFolderItems,
  updateFolders,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FolderView));
